export function getQuotasSchedule() {
    const previoHotSale = 1746403200000; //05/05 -> 9
    const inicioHotSale = 1746748800000; //09/05 -> 5
    const finHotSale = 1747267200000; //15/05 -> 7
    const fechaDefecto = 1747699200000; //20/05 -> 12
    const ahora = Date.now();

    let quota = 12 ;
    let enabledSegment = true;

    if (ahora > previoHotSale && ahora < inicioHotSale) {
        quota = 9;
        enabledSegment = false;
    } else if (ahora >= inicioHotSale && ahora < finHotSale) {
        quota = 5;
        enabledSegment = false;
    } else if (ahora >= finHotSale && ahora < fechaDefecto) {
        quota = 7;
        enabledSegment = false;
    }

    return { quota, enabledSegment };
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/quotaSchedule.js